import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AppTypeEnum } from '../../enums';

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<InfoDialogComponent>);
  public content: string = '';
  public title: string = '';

  private static readonly appContent: Record<AppTypeEnum, { title: string; content: string }> = {
    [AppTypeEnum.binding]: {
      title: 'BindingApp',
      content:
        'This app makes it easy to activate the keynexis® storage unit control after the physical installation. Simply scan the QR code on the unit control and photograph the storage unit number on the door to connect it to the Management Portal. The keynexis® storage unit control does not need to be connected to Wi-Fi or 24 volts during the binding process.',
    },
    [AppTypeEnum.testing]: {
      title: 'TestingApp',
      content:
        'This app allows you to test the connection to the keynexis® storage unit control. It is useful for troubleshooting and ensuring that the control is functioning correctly.',
    },
    [AppTypeEnum.stocking]: {
      title: 'StockingApp',
      content:
        'This app is designed for stocking operations. It helps you manage the inventory and ensure that the storage unit is stocked correctly.',
    },
  };

  constructor(

    @Inject(DIALOG_DATA) public data: { appType: AppTypeEnum },
  ) {
    const info = InfoDialogComponent.appContent[data.appType];
    if (info) {
      this.title = info.title;
      this.content = info.content;
    }
  }

  ngOnInit(): void {
    if (this.data.appType === AppTypeEnum.binding) {
      this.title = "BindingApp";
      this.content = "This app makes it easy to activate the keynexis® storage unit control after the physical installation. Simply scan the QR code on the unit control and photograph the storage unit number on the door to connect it to the Management Portal. The keynexis® storage unit control does not need to be connected to Wi-Fi or 24 volts during the binding process.";
    }
    else if (this.data.appType === AppTypeEnum.testing) {
      this.title = "TestingApp";
      this.content = "This app allows you to test the connection to the keynexis® storage unit control. It is useful for troubleshooting and ensuring that the control is functioning correctly.";
    }
    else if (this.data.appType === AppTypeEnum.stocking) {
      this.title = "StockingApp";
      this.content = "This app is designed for stocking operations. It helps you manage the inventory and ensure that the storage unit is stocked correctly.";
    }
  }
}
